import { useEffect, useState } from 'react';
import { api } from './api.ts';

/**
 * 浏览器扩展的 Chrome 应用商店链接（老板上架之后在运维后台「运营参数 › 扩展」填，2026-10-31）。
 * 填了：扩展状态页出现安装按钮，功能介绍页、首页的「还没上架」那几句自动换掉。没填（null）：照「还没上架」说。
 * 只认 Chrome 应用商店的 https 网址（和服务器那一份同一条规矩）
 */
export function isStoreUrl(v: unknown): v is string {
  if (typeof v !== 'string' || v === '' || v.length > 300) return false;
  try {
    const u = new URL(v);
    return u.protocol === 'https:' && (u.hostname === 'chromewebstore.google.com' || u.hostname === 'chrome.google.com');
  } catch {
    return false;
  }
}

/* 一个页面里好几个地方要它（每个状态标签都问一次的话就是十几个请求）：一次页面加载只问一次 */
let pending: Promise<string | null> | null = null;
export function loadExtStoreUrl(): Promise<string | null> {
  if (pending === null) {
    pending = api.get<{ storeUrl: string | null }>('/public/extension')
      .then(r => (r.ok && isStoreUrl(r.data.storeUrl) ? r.data.storeUrl : null))
      .catch(() => null);
  }
  return pending;
}

/**
 * **只给构建时的预渲染用**：先把构建时问到的商店链接塞进来，渲染出来的 HTML 才不会写「扩展即将上架」。
 * 浏览器里没人调它，useExtStoreUrl 照旧从 undefined（还在问）开始
 */
let primed: string | null | undefined = undefined;
export function primeExtStoreUrl(v: string | null): void {
  primed = isStoreUrl(v) ? v : null;
}

/** undefined = 还在问；null = 还没上架；字符串 = 商店链接 */
export function useExtStoreUrl(): string | null | undefined {
  const [v, setV] = useState<string | null | undefined>(primed);
  useEffect(() => {
    let alive = true;
    void loadExtStoreUrl().then(u => { if (alive) setV(u); });
    return () => { alive = false; };
  }, []);
  return v;
}
